import {
  useStartGoogleDriveSourceConnect,
  useStartGoogleMemberExternalConnect,
  useStartMicrosoftMemberExternalConnect,
  useStartMicrosoftTenantConsent,
  useStartXeroHubConnect,
} from '@/hooks';
import type { OauthIntegrationKind } from '@vivport/backend/types';

export type OauthConnectStarters = Record<OauthIntegrationKind, () => Promise<{ authUrl: string }>>;

export function useOauthConnectStarters(): OauthConnectStarters {
  const startGoogleAccount = useStartGoogleMemberExternalConnect();
  const startMicrosoftAccount = useStartMicrosoftMemberExternalConnect();
  const startGoogleDrive = useStartGoogleDriveSourceConnect();
  const startMicrosoftTenant = useStartMicrosoftTenantConsent();
  const startXero = useStartXeroHubConnect();

  return {
    'google-account': () => startGoogleAccount.mutateAsync(),
    'microsoft-account': () => startMicrosoftAccount.mutateAsync(),
    'google-drive': () => startGoogleDrive.mutateAsync(),
    'microsoft-tenant': () => startMicrosoftTenant.mutateAsync(),
    xero: () => startXero.mutateAsync(),
  };
}
